import React from "react";
import { SEVERITY_META } from "../../lib/constants";
import { cn } from "../../lib/utils";

export function SeverityChip({ severity, className, "data-testid": testId }) {
  const meta = SEVERITY_META[severity];
  if (!meta) {
    return (
      <span
        data-testid={testId || "severity-chip-unknown"}
        className={cn("inline-flex items-center rounded px-2 py-0.5 text-xs bg-slate-100 text-slate-700", className)}
      >
        {severity || "—"}
      </span>
    );
  }
  return (
    <span
      role="status"
      aria-label={meta.aria}
      data-testid={testId || `severity-chip-${severity.toLowerCase()}`}
      className={cn(
        "inline-flex items-center gap-1.5 rounded px-2 py-0.5 text-xs font-medium ring-1",
        meta.bg, meta.text, meta.ring,
        className,
      )}
    >
      <span aria-hidden="true" className={cn("h-1.5 w-1.5 rounded-full", meta.dot)} />
      {meta.label}
    </span>
  );
}
